export default __webpack_public_path__ + "static/media/ev-charge-point.43ddb61c.svg";